import React, { useCallback, useMemo } from 'react'

import { Box, Checkbox } from '@chakra-ui/react'
import { useField, useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

import {
  addLeadingZeroToDistrict,
  convertDistrictToNumeric,
  hasPermission,
} from '../../../../../utils'
import { ConditionalRender } from '../../../../ui'

const DistrictLockField = ({ field = 'visible_to_district_only' }) => {
  const user = useSelector(state => state.auth.user)

  const { values, setFieldValue } = useFormikContext()
  const [formikField] = useField(field)

  const showDistrictLock = useMemo(
    () =>
      !values.district ||
      addLeadingZeroToDistrict(values.district) === user.district ||
      hasPermission(user, 'directory.constituent.view_all_constituents'),
    [values.district, user.district]
  )
  const handleDistrictLock = useCallback(
    e => setFieldValue(field, e.target.checked),
    [setFieldValue, field]
  )

  return (
    <ConditionalRender condition={showDistrictLock}>
      <Box>
        <Checkbox
          id={`constituent-district-lock-${field}`}
          isChecked={formikField.value}
          onChange={handleDistrictLock}
        >
          Set visible to District {convertDistrictToNumeric(values.district)}{' '}
          Only
        </Checkbox>
      </Box>
    </ConditionalRender>
  )
}

export default DistrictLockField
